import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountProfile, AccountState } from "./types";
import { getAccountProfile, updateAccountProfile } from "./api";

const initialState: AccountState = {
  parentProfile: null,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAccountProfile.fulfilled, (state: AccountState, action: PayloadAction<any>) => {
        state.parentProfile = action.payload;
      })
      .addCase(updateAccountProfile.fulfilled, (state: AccountState, action: PayloadAction<any>) => {
        state.parentProfile = action.payload;
      });
  },
});

export const accountActions = { ...accountSlice.actions };

export default accountSlice.reducer;
